// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminCompanies = (client) => ({
    /**
     * `POST /admin/companies`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/admin/companies/route.ts
     */
    create: (body, query, headers) => client.fetch("/admin/companies", { method: "POST", body, query, headers }),
    /**
     * `POST /admin/companies/:id/approval-settings`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/admin/companies/[id]/approval-settings/route.ts
     */
    createApprovalSetting: (id, body, query, headers) => client.fetch(buildPath("/admin/companies/:id/approval-settings", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /admin/companies/:id/employees`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/admin/companies/[id]/employees/route.ts
     */
    createEmployee: (id, body, query, headers) => client.fetch(buildPath("/admin/companies/:id/employees", [id]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /admin/companies/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/admin/companies/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/admin/companies/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /admin/companies/:id/customer-group/:customerGroupId`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/admin/companies/[id]/customer-group/[customerGroupId]/route.ts
     */
    deleteCustomerGroup: (id, customerGroupId, body, query, headers) => client.fetch(buildPath("/admin/companies/:id/customer-group/:customerGroupId", [id, customerGroupId]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /admin/companies/:id/employees/:employeeId`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/admin/companies/[id]/employees/[employeeId]/route.ts
     */
    deleteEmployee: (id, employeeId, body, query, headers) => client.fetch(buildPath("/admin/companies/:id/employees/:employeeId", [id, employeeId]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /admin/companies`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/admin/companies/route.ts
     */
    list: (query, headers) => client.fetch("/admin/companies", { method: "GET", query, headers }),
    /**
     * `GET /admin/companies/:id/approval-settings`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/admin/companies/[id]/approval-settings/route.ts
     */
    listApprovalSettings: (id, query, headers) => client.fetch(buildPath("/admin/companies/:id/approval-settings", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/companies/:id/employees`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/admin/companies/[id]/employees/route.ts
     */
    listEmployees: (id, query, headers) => client.fetch(buildPath("/admin/companies/:id/employees", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/companies/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/admin/companies/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/admin/companies/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/companies/:id/employees/:employeeId`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/admin/companies/[id]/employees/[employeeId]/route.ts
     */
    retrieveEmployee: (id, employeeId, query, headers) => client.fetch(buildPath("/admin/companies/:id/employees/:employeeId", [id, employeeId]), { method: "GET", query, headers }),
    /**
     * `POST /admin/companies/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/admin/companies/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/admin/companies/:id", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /admin/companies/:id/customer-group`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/admin/companies/[id]/customer-group/route.ts
     */
    updateCustomerGroup: (id, body, query, headers) => client.fetch(buildPath("/admin/companies/:id/customer-group", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /admin/companies/:id/employees/:employeeId`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/admin/companies/[id]/employees/[employeeId]/route.ts
     */
    updateEmployee: (id, employeeId, body, query, headers) => client.fetch(buildPath("/admin/companies/:id/employees/:employeeId", [id, employeeId]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=companies.js.map